// automatically generated by the FlatBuffers compiler, do not modify

/**
 * @enum {number}
 */
export namespace com.tableausoftware.telemetry.protocol{
export enum TfbStandardProperties{
  PodName= 0,
  SiteLuid= 1,
  ProductFamily= 2,
  ProductVersion= 3,
  Timestamp= 4,
  HostName= 5,
  ServiceName= 6,
  Events15Min= 7,
  FailedEvents15Min= 8,
  MaxTime15Min= 9,
  MinTime15Min= 10,
  P50Time15Min= 11,
  P75Time15Min= 12,
  MACAddress= 13,
  OsName= 14,
  OsVersion= 15,
  Count= 16,
  PodUUID= 17,
  TsmClusterId= 18,
  KubePodName= 19
};
}

/**
 * @enum {number}
 */
export namespace com.tableausoftware.telemetry.protocol{
export enum TfbPropertyValue{
  NONE= 0,
  TfbLongValue= 1,
  TfbDoubleValue= 2,
  TfbStringValue= 3
};

export function unionToTfbPropertyValue(
  type: TfbPropertyValue,
  accessor: (obj:com.tableausoftware.telemetry.protocol.TfbDoubleValue|com.tableausoftware.telemetry.protocol.TfbLongValue|com.tableausoftware.telemetry.protocol.TfbStringValue) => com.tableausoftware.telemetry.protocol.TfbDoubleValue|com.tableausoftware.telemetry.protocol.TfbLongValue|com.tableausoftware.telemetry.protocol.TfbStringValue|null
): com.tableausoftware.telemetry.protocol.TfbDoubleValue|com.tableausoftware.telemetry.protocol.TfbLongValue|com.tableausoftware.telemetry.protocol.TfbStringValue|null {
  switch(com.tableausoftware.telemetry.protocol.TfbPropertyValue[type]) {
    case 'NONE': return null; 
    case 'TfbLongValue': return accessor(new com.tableausoftware.telemetry.protocol.TfbLongValue())! as com.tableausoftware.telemetry.protocol.TfbLongValue;
    case 'TfbDoubleValue': return accessor(new com.tableausoftware.telemetry.protocol.TfbDoubleValue())! as com.tableausoftware.telemetry.protocol.TfbDoubleValue;
    case 'TfbStringValue': return accessor(new com.tableausoftware.telemetry.protocol.TfbStringValue())! as com.tableausoftware.telemetry.protocol.TfbStringValue;
    default: return null;
  }
}

export function unionListToTfbPropertyValue(
  type: TfbPropertyValue, 
  accessor: (index: number, obj:com.tableausoftware.telemetry.protocol.TfbDoubleValue|com.tableausoftware.telemetry.protocol.TfbLongValue|com.tableausoftware.telemetry.protocol.TfbStringValue) => com.tableausoftware.telemetry.protocol.TfbDoubleValue|com.tableausoftware.telemetry.protocol.TfbLongValue|com.tableausoftware.telemetry.protocol.TfbStringValue|null, 
  index: number
): com.tableausoftware.telemetry.protocol.TfbDoubleValue|com.tableausoftware.telemetry.protocol.TfbLongValue|com.tableausoftware.telemetry.protocol.TfbStringValue|null {
  switch(com.tableausoftware.telemetry.protocol.TfbPropertyValue[type]) {
    case 'NONE': return null; 
    case 'TfbLongValue': return accessor(index, new com.tableausoftware.telemetry.protocol.TfbLongValue())! as com.tableausoftware.telemetry.protocol.TfbLongValue;
    case 'TfbDoubleValue': return accessor(index, new com.tableausoftware.telemetry.protocol.TfbDoubleValue())! as com.tableausoftware.telemetry.protocol.TfbDoubleValue;
    case 'TfbStringValue': return accessor(index, new com.tableausoftware.telemetry.protocol.TfbStringValue())! as com.tableausoftware.telemetry.protocol.TfbStringValue;
    default: return null;
  }
}
}

/**
 * @enum {number}
 */
export namespace com.tableausoftware.telemetry.protocol{
export enum TfbPropertyKey{
  NONE= 0,
  TfbStringPropertyKey= 1,
  TfbStandardPropertyKey= 2
};

export function unionToTfbPropertyKey(
  type: TfbPropertyKey,
  accessor: (obj:com.tableausoftware.telemetry.protocol.TfbStandardPropertyKey|com.tableausoftware.telemetry.protocol.TfbStringPropertyKey) => com.tableausoftware.telemetry.protocol.TfbStandardPropertyKey|com.tableausoftware.telemetry.protocol.TfbStringPropertyKey|null
): com.tableausoftware.telemetry.protocol.TfbStandardPropertyKey|com.tableausoftware.telemetry.protocol.TfbStringPropertyKey|null {
  switch(com.tableausoftware.telemetry.protocol.TfbPropertyKey[type]) {
    case 'NONE': return null; 
    case 'TfbStringPropertyKey': return accessor(new com.tableausoftware.telemetry.protocol.TfbStringPropertyKey())! as com.tableausoftware.telemetry.protocol.TfbStringPropertyKey;
    case 'TfbStandardPropertyKey': return accessor(new com.tableausoftware.telemetry.protocol.TfbStandardPropertyKey())! as com.tableausoftware.telemetry.protocol.TfbStandardPropertyKey;
    default: return null;
  }
}

export function unionListToTfbPropertyKey(
  type: TfbPropertyKey, 
  accessor: (index: number, obj:com.tableausoftware.telemetry.protocol.TfbStandardPropertyKey|com.tableausoftware.telemetry.protocol.TfbStringPropertyKey) => com.tableausoftware.telemetry.protocol.TfbStandardPropertyKey|com.tableausoftware.telemetry.protocol.TfbStringPropertyKey|null, 
  index: number
): com.tableausoftware.telemetry.protocol.TfbStandardPropertyKey|com.tableausoftware.telemetry.protocol.TfbStringPropertyKey|null {
  switch(com.tableausoftware.telemetry.protocol.TfbPropertyKey[type]) {
    case 'NONE': return null; 
    case 'TfbStringPropertyKey': return accessor(index, new com.tableausoftware.telemetry.protocol.TfbStringPropertyKey())! as com.tableausoftware.telemetry.protocol.TfbStringPropertyKey;
    case 'TfbStandardPropertyKey': return accessor(index, new com.tableausoftware.telemetry.protocol.TfbStandardPropertyKey())! as com.tableausoftware.telemetry.protocol.TfbStandardPropertyKey;
    default: return null;
  }
}
}

/**
 * @enum {number}
 */
export namespace com.tableausoftware.telemetry.protocol{
export enum TfbEventType{
  Put= 0,
  Metric= 1
};
}

/**
 * @enum {number}
 */
export namespace com.tableausoftware.telemetry.protocol{
export enum TfbEventErrorCode{
  Unknown= 0,
  BlockedCategory= 600,
  BlockedCategories= 601
};
}

/**
 * @constructor
 */
export namespace com.tableausoftware.telemetry.protocol{
export class TfbLongValue {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns TfbLongValue
 */
__init(i:number, bb:flatbuffers.ByteBuffer):TfbLongValue {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbLongValue= obj
 * @returns TfbLongValue
 */
static getRootAsTfbLongValue(bb:flatbuffers.ByteBuffer, obj?:TfbLongValue):TfbLongValue {
  return (obj || new TfbLongValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbLongValue= obj
 * @returns TfbLongValue
 */
static getSizePrefixedRootAsTfbLongValue(bb:flatbuffers.ByteBuffer, obj?:TfbLongValue):TfbLongValue {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TfbLongValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns flatbuffers.Long
 */
Value():flatbuffers.Long {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : this.bb!.createLong(0, 0);
};

/**
 * @param flatbuffers.Builder builder
 */
static startTfbLongValue(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Long Value
 */
static addValue(builder:flatbuffers.Builder, Value:flatbuffers.Long) {
  builder.addFieldInt64(0, Value, builder.createLong(0, 0));
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endTfbLongValue(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createTfbLongValue(builder:flatbuffers.Builder, Value:flatbuffers.Long):flatbuffers.Offset {
  TfbLongValue.startTfbLongValue(builder);
  TfbLongValue.addValue(builder, Value);
  return TfbLongValue.endTfbLongValue(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.telemetry.protocol{
export class TfbDoubleValue {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns TfbDoubleValue
 */
__init(i:number, bb:flatbuffers.ByteBuffer):TfbDoubleValue {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbDoubleValue= obj
 * @returns TfbDoubleValue
 */
static getRootAsTfbDoubleValue(bb:flatbuffers.ByteBuffer, obj?:TfbDoubleValue):TfbDoubleValue {
  return (obj || new TfbDoubleValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbDoubleValue= obj
 * @returns TfbDoubleValue
 */
static getSizePrefixedRootAsTfbDoubleValue(bb:flatbuffers.ByteBuffer, obj?:TfbDoubleValue):TfbDoubleValue {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TfbDoubleValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns number
 */
Value():number {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : 0.0;
};

/**
 * @param flatbuffers.Builder builder
 */
static startTfbDoubleValue(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param number Value
 */
static addValue(builder:flatbuffers.Builder, Value:number) {
  builder.addFieldFloat64(0, Value, 0.0);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endTfbDoubleValue(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createTfbDoubleValue(builder:flatbuffers.Builder, Value:number):flatbuffers.Offset {
  TfbDoubleValue.startTfbDoubleValue(builder);
  TfbDoubleValue.addValue(builder, Value);
  return TfbDoubleValue.endTfbDoubleValue(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.telemetry.protocol{
export class TfbStringValue {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns TfbStringValue
 */
__init(i:number, bb:flatbuffers.ByteBuffer):TfbStringValue {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbStringValue= obj
 * @returns TfbStringValue
 */
static getRootAsTfbStringValue(bb:flatbuffers.ByteBuffer, obj?:TfbStringValue):TfbStringValue {
  return (obj || new TfbStringValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbStringValue= obj
 * @returns TfbStringValue
 */
static getSizePrefixedRootAsTfbStringValue(bb:flatbuffers.ByteBuffer, obj?:TfbStringValue):TfbStringValue {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TfbStringValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
Value():string|null
Value(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
Value(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param flatbuffers.Builder builder
 */
static startTfbStringValue(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset ValueOffset
 */
static addValue(builder:flatbuffers.Builder, ValueOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, ValueOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endTfbStringValue(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createTfbStringValue(builder:flatbuffers.Builder, ValueOffset:flatbuffers.Offset):flatbuffers.Offset {
  TfbStringValue.startTfbStringValue(builder);
  TfbStringValue.addValue(builder, ValueOffset);
  return TfbStringValue.endTfbStringValue(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.telemetry.protocol{
export class TfbBooleanValue {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns TfbBooleanValue
 */
__init(i:number, bb:flatbuffers.ByteBuffer):TfbBooleanValue {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbBooleanValue= obj
 * @returns TfbBooleanValue
 */
static getRootAsTfbBooleanValue(bb:flatbuffers.ByteBuffer, obj?:TfbBooleanValue):TfbBooleanValue {
  return (obj || new TfbBooleanValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbBooleanValue= obj
 * @returns TfbBooleanValue
 */
static getSizePrefixedRootAsTfbBooleanValue(bb:flatbuffers.ByteBuffer, obj?:TfbBooleanValue):TfbBooleanValue {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TfbBooleanValue()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns boolean
 */
Value():boolean {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false;
};

/**
 * @param flatbuffers.Builder builder
 */
static startTfbBooleanValue(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param boolean Value
 */
static addValue(builder:flatbuffers.Builder, Value:boolean) {
  builder.addFieldInt8(0, +Value, +false);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endTfbBooleanValue(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createTfbBooleanValue(builder:flatbuffers.Builder, Value:boolean):flatbuffers.Offset {
  TfbBooleanValue.startTfbBooleanValue(builder);
  TfbBooleanValue.addValue(builder, Value);
  return TfbBooleanValue.endTfbBooleanValue(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.telemetry.protocol{
export class TfbStringPropertyKey {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns TfbStringPropertyKey
 */
__init(i:number, bb:flatbuffers.ByteBuffer):TfbStringPropertyKey {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbStringPropertyKey= obj
 * @returns TfbStringPropertyKey
 */
static getRootAsTfbStringPropertyKey(bb:flatbuffers.ByteBuffer, obj?:TfbStringPropertyKey):TfbStringPropertyKey {
  return (obj || new TfbStringPropertyKey()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbStringPropertyKey= obj
 * @returns TfbStringPropertyKey
 */
static getSizePrefixedRootAsTfbStringPropertyKey(bb:flatbuffers.ByteBuffer, obj?:TfbStringPropertyKey):TfbStringPropertyKey {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TfbStringPropertyKey()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
Key():string|null
Key(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
Key(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @param flatbuffers.Builder builder
 */
static startTfbStringPropertyKey(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset KeyOffset
 */
static addKey(builder:flatbuffers.Builder, KeyOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, KeyOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endTfbStringPropertyKey(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createTfbStringPropertyKey(builder:flatbuffers.Builder, KeyOffset:flatbuffers.Offset):flatbuffers.Offset {
  TfbStringPropertyKey.startTfbStringPropertyKey(builder);
  TfbStringPropertyKey.addKey(builder, KeyOffset);
  return TfbStringPropertyKey.endTfbStringPropertyKey(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.telemetry.protocol{
export class TfbStandardPropertyKey {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns TfbStandardPropertyKey
 */
__init(i:number, bb:flatbuffers.ByteBuffer):TfbStandardPropertyKey {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbStandardPropertyKey= obj
 * @returns TfbStandardPropertyKey
 */
static getRootAsTfbStandardPropertyKey(bb:flatbuffers.ByteBuffer, obj?:TfbStandardPropertyKey):TfbStandardPropertyKey {
  return (obj || new TfbStandardPropertyKey()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbStandardPropertyKey= obj
 * @returns TfbStandardPropertyKey
 */
static getSizePrefixedRootAsTfbStandardPropertyKey(bb:flatbuffers.ByteBuffer, obj?:TfbStandardPropertyKey):TfbStandardPropertyKey {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TfbStandardPropertyKey()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns com.tableausoftware.telemetry.protocol.TfbStandardProperties
 */
Key():com.tableausoftware.telemetry.protocol.TfbStandardProperties {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? /**  */ (this.bb!.readInt32(this.bb_pos + offset)) : com.tableausoftware.telemetry.protocol.TfbStandardProperties.PodName;
};

/**
 * @param flatbuffers.Builder builder
 */
static startTfbStandardPropertyKey(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param com.tableausoftware.telemetry.protocol.TfbStandardProperties Key
 */
static addKey(builder:flatbuffers.Builder, Key:com.tableausoftware.telemetry.protocol.TfbStandardProperties) {
  builder.addFieldInt32(0, Key, com.tableausoftware.telemetry.protocol.TfbStandardProperties.PodName);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endTfbStandardPropertyKey(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createTfbStandardPropertyKey(builder:flatbuffers.Builder, Key:com.tableausoftware.telemetry.protocol.TfbStandardProperties):flatbuffers.Offset {
  TfbStandardPropertyKey.startTfbStandardPropertyKey(builder);
  TfbStandardPropertyKey.addKey(builder, Key);
  return TfbStandardPropertyKey.endTfbStandardPropertyKey(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.telemetry.protocol{
export class TfbProperty {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns TfbProperty
 */
__init(i:number, bb:flatbuffers.ByteBuffer):TfbProperty {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbProperty= obj
 * @returns TfbProperty
 */
static getRootAsTfbProperty(bb:flatbuffers.ByteBuffer, obj?:TfbProperty):TfbProperty {
  return (obj || new TfbProperty()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbProperty= obj
 * @returns TfbProperty
 */
static getSizePrefixedRootAsTfbProperty(bb:flatbuffers.ByteBuffer, obj?:TfbProperty):TfbProperty {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TfbProperty()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns com.tableausoftware.telemetry.protocol.TfbPropertyKey
 */
NameType():com.tableausoftware.telemetry.protocol.TfbPropertyKey {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? /**  */ (this.bb!.readUint8(this.bb_pos + offset)) : com.tableausoftware.telemetry.protocol.TfbPropertyKey.NONE;
};

/**
 * @param flatbuffers.Table obj
 * @returns ?flatbuffers.Table
 */
Name<T extends flatbuffers.Table>(obj:T):T|null {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
};

/**
 * @returns com.tableausoftware.telemetry.protocol.TfbPropertyValue
 */
ValueType():com.tableausoftware.telemetry.protocol.TfbPropertyValue {
  var offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? /**  */ (this.bb!.readUint8(this.bb_pos + offset)) : com.tableausoftware.telemetry.protocol.TfbPropertyValue.NONE;
};

/**
 * @param flatbuffers.Table obj
 * @returns ?flatbuffers.Table
 */
Value<T extends flatbuffers.Table>(obj:T):T|null {
  var offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
};

/**
 * @param flatbuffers.Builder builder
 */
static startTfbProperty(builder:flatbuffers.Builder) {
  builder.startObject(4);
};

/**
 * @param flatbuffers.Builder builder
 * @param com.tableausoftware.telemetry.protocol.TfbPropertyKey NameType
 */
static addNameType(builder:flatbuffers.Builder, NameType:com.tableausoftware.telemetry.protocol.TfbPropertyKey) {
  builder.addFieldInt8(0, NameType, com.tableausoftware.telemetry.protocol.TfbPropertyKey.NONE);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset NameOffset
 */
static addName(builder:flatbuffers.Builder, NameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, NameOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param com.tableausoftware.telemetry.protocol.TfbPropertyValue ValueType
 */
static addValueType(builder:flatbuffers.Builder, ValueType:com.tableausoftware.telemetry.protocol.TfbPropertyValue) {
  builder.addFieldInt8(2, ValueType, com.tableausoftware.telemetry.protocol.TfbPropertyValue.NONE);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset ValueOffset
 */
static addValue(builder:flatbuffers.Builder, ValueOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, ValueOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endTfbProperty(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createTfbProperty(builder:flatbuffers.Builder, NameType:com.tableausoftware.telemetry.protocol.TfbPropertyKey, NameOffset:flatbuffers.Offset, ValueType:com.tableausoftware.telemetry.protocol.TfbPropertyValue, ValueOffset:flatbuffers.Offset):flatbuffers.Offset {
  TfbProperty.startTfbProperty(builder);
  TfbProperty.addNameType(builder, NameType);
  TfbProperty.addName(builder, NameOffset);
  TfbProperty.addValueType(builder, ValueType);
  TfbProperty.addValue(builder, ValueOffset);
  return TfbProperty.endTfbProperty(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.telemetry.protocol{
export class TfbEvent {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns TfbEvent
 */
__init(i:number, bb:flatbuffers.ByteBuffer):TfbEvent {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbEvent= obj
 * @returns TfbEvent
 */
static getRootAsTfbEvent(bb:flatbuffers.ByteBuffer, obj?:TfbEvent):TfbEvent {
  return (obj || new TfbEvent()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbEvent= obj
 * @returns TfbEvent
 */
static getSizePrefixedRootAsTfbEvent(bb:flatbuffers.ByteBuffer, obj?:TfbEvent):TfbEvent {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TfbEvent()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns flatbuffers.Long
 */
Id():flatbuffers.Long {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : this.bb!.createLong(0, 0);
};

/**
 * @returns com.tableausoftware.telemetry.protocol.TfbEventType
 */
Type():com.tableausoftware.telemetry.protocol.TfbEventType {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? /**  */ (this.bb!.readInt8(this.bb_pos + offset)) : com.tableausoftware.telemetry.protocol.TfbEventType.Put;
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
Category():string|null
Category(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
Category(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns number
 */
Version():number {
  var offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
};

/**
 * @param number index
 * @param com.tableausoftware.telemetry.protocol.TfbProperty= obj
 * @returns com.tableausoftware.telemetry.protocol.TfbProperty
 */
Properties(index: number, obj?:com.tableausoftware.telemetry.protocol.TfbProperty):com.tableausoftware.telemetry.protocol.TfbProperty|null {
  var offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? (obj || new com.tableausoftware.telemetry.protocol.TfbProperty()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
PropertiesLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @returns flatbuffers.Long
 */
SendTimestamp():flatbuffers.Long {
  var offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : this.bb!.createLong(0, 0);
};

/**
 * @param flatbuffers.Builder builder
 */
static startTfbEvent(builder:flatbuffers.Builder) {
  builder.startObject(6);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Long Id
 */
static addId(builder:flatbuffers.Builder, Id:flatbuffers.Long) {
  builder.addFieldInt64(0, Id, builder.createLong(0, 0));
};

/**
 * @param flatbuffers.Builder builder
 * @param com.tableausoftware.telemetry.protocol.TfbEventType Type
 */
static addType(builder:flatbuffers.Builder, Type:com.tableausoftware.telemetry.protocol.TfbEventType) {
  builder.addFieldInt8(1, Type, com.tableausoftware.telemetry.protocol.TfbEventType.Put);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset CategoryOffset
 */
static addCategory(builder:flatbuffers.Builder, CategoryOffset:flatbuffers.Offset) {
  builder.addFieldOffset(2, CategoryOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param number Version
 */
static addVersion(builder:flatbuffers.Builder, Version:number) {
  builder.addFieldInt16(3, Version, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset PropertiesOffset
 */
static addProperties(builder:flatbuffers.Builder, PropertiesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, PropertiesOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createPropertiesVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startPropertiesVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Long SendTimestamp
 */
static addSendTimestamp(builder:flatbuffers.Builder, SendTimestamp:flatbuffers.Long) {
  builder.addFieldInt64(5, SendTimestamp, builder.createLong(0, 0));
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endTfbEvent(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createTfbEvent(builder:flatbuffers.Builder, Id:flatbuffers.Long, Type:com.tableausoftware.telemetry.protocol.TfbEventType, CategoryOffset:flatbuffers.Offset, Version:number, PropertiesOffset:flatbuffers.Offset, SendTimestamp:flatbuffers.Long):flatbuffers.Offset {
  TfbEvent.startTfbEvent(builder);
  TfbEvent.addId(builder, Id);
  TfbEvent.addType(builder, Type);
  TfbEvent.addCategory(builder, CategoryOffset);
  TfbEvent.addVersion(builder, Version);
  TfbEvent.addProperties(builder, PropertiesOffset);
  TfbEvent.addSendTimestamp(builder, SendTimestamp);
  return TfbEvent.endTfbEvent(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.telemetry.protocol{
export class TfbEventSet {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns TfbEventSet
 */
__init(i:number, bb:flatbuffers.ByteBuffer):TfbEventSet {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbEventSet= obj
 * @returns TfbEventSet
 */
static getRootAsTfbEventSet(bb:flatbuffers.ByteBuffer, obj?:TfbEventSet):TfbEventSet {
  return (obj || new TfbEventSet()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbEventSet= obj
 * @returns TfbEventSet
 */
static getSizePrefixedRootAsTfbEventSet(bb:flatbuffers.ByteBuffer, obj?:TfbEventSet):TfbEventSet {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TfbEventSet()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param number index
 * @param com.tableausoftware.telemetry.protocol.TfbEvent= obj
 * @returns com.tableausoftware.telemetry.protocol.TfbEvent
 */
Events(index: number, obj?:com.tableausoftware.telemetry.protocol.TfbEvent):com.tableausoftware.telemetry.protocol.TfbEvent|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new com.tableausoftware.telemetry.protocol.TfbEvent()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
EventsLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param flatbuffers.Builder builder
 */
static startTfbEventSet(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset EventsOffset
 */
static addEvents(builder:flatbuffers.Builder, EventsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, EventsOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createEventsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startEventsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endTfbEventSet(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createTfbEventSet(builder:flatbuffers.Builder, EventsOffset:flatbuffers.Offset):flatbuffers.Offset {
  TfbEventSet.startTfbEventSet(builder);
  TfbEventSet.addEvents(builder, EventsOffset);
  return TfbEventSet.endTfbEventSet(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.telemetry.protocol{
export class TfbEventError {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns TfbEventError
 */
__init(i:number, bb:flatbuffers.ByteBuffer):TfbEventError {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbEventError= obj
 * @returns TfbEventError
 */
static getRootAsTfbEventError(bb:flatbuffers.ByteBuffer, obj?:TfbEventError):TfbEventError {
  return (obj || new TfbEventError()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbEventError= obj
 * @returns TfbEventError
 */
static getSizePrefixedRootAsTfbEventError(bb:flatbuffers.ByteBuffer, obj?:TfbEventError):TfbEventError {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TfbEventError()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @returns com.tableausoftware.telemetry.protocol.TfbEventErrorCode
 */
Code():com.tableausoftware.telemetry.protocol.TfbEventErrorCode {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? /**  */ (this.bb!.readInt16(this.bb_pos + offset)) : com.tableausoftware.telemetry.protocol.TfbEventErrorCode.Unknown;
};

/**
 * @param flatbuffers.Encoding= optionalEncoding
 * @returns string|Uint8Array|null
 */
Message():string|null
Message(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
Message(optionalEncoding?:any):string|Uint8Array|null {
  var offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
};

/**
 * @returns flatbuffers.Long
 */
EventId():flatbuffers.Long {
  var offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readInt64(this.bb_pos + offset) : this.bb!.createLong(0, 0);
};

/**
 * @param flatbuffers.Builder builder
 */
static startTfbEventError(builder:flatbuffers.Builder) {
  builder.startObject(3);
};

/**
 * @param flatbuffers.Builder builder
 * @param com.tableausoftware.telemetry.protocol.TfbEventErrorCode Code
 */
static addCode(builder:flatbuffers.Builder, Code:com.tableausoftware.telemetry.protocol.TfbEventErrorCode) {
  builder.addFieldInt16(0, Code, com.tableausoftware.telemetry.protocol.TfbEventErrorCode.Unknown);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset MessageOffset
 */
static addMessage(builder:flatbuffers.Builder, MessageOffset:flatbuffers.Offset) {
  builder.addFieldOffset(1, MessageOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Long EventId
 */
static addEventId(builder:flatbuffers.Builder, EventId:flatbuffers.Long) {
  builder.addFieldInt64(2, EventId, builder.createLong(0, 0));
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endTfbEventError(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createTfbEventError(builder:flatbuffers.Builder, Code:com.tableausoftware.telemetry.protocol.TfbEventErrorCode, MessageOffset:flatbuffers.Offset, EventId:flatbuffers.Long):flatbuffers.Offset {
  TfbEventError.startTfbEventError(builder);
  TfbEventError.addCode(builder, Code);
  TfbEventError.addMessage(builder, MessageOffset);
  TfbEventError.addEventId(builder, EventId);
  return TfbEventError.endTfbEventError(builder);
}
}
}
/**
 * @constructor
 */
export namespace com.tableausoftware.telemetry.protocol{
export class TfbEventErrorSet {
  bb: flatbuffers.ByteBuffer|null = null;

  bb_pos:number = 0;
/**
 * @param number i
 * @param flatbuffers.ByteBuffer bb
 * @returns TfbEventErrorSet
 */
__init(i:number, bb:flatbuffers.ByteBuffer):TfbEventErrorSet {
  this.bb_pos = i;
  this.bb = bb;
  return this;
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbEventErrorSet= obj
 * @returns TfbEventErrorSet
 */
static getRootAsTfbEventErrorSet(bb:flatbuffers.ByteBuffer, obj?:TfbEventErrorSet):TfbEventErrorSet {
  return (obj || new TfbEventErrorSet()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param flatbuffers.ByteBuffer bb
 * @param TfbEventErrorSet= obj
 * @returns TfbEventErrorSet
 */
static getSizePrefixedRootAsTfbEventErrorSet(bb:flatbuffers.ByteBuffer, obj?:TfbEventErrorSet):TfbEventErrorSet {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new TfbEventErrorSet()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
};

/**
 * @param number index
 * @param com.tableausoftware.telemetry.protocol.TfbEventError= obj
 * @returns com.tableausoftware.telemetry.protocol.TfbEventError
 */
Errors(index: number, obj?:com.tableausoftware.telemetry.protocol.TfbEventError):com.tableausoftware.telemetry.protocol.TfbEventError|null {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? (obj || new com.tableausoftware.telemetry.protocol.TfbEventError()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!) : null;
};

/**
 * @returns number
 */
ErrorsLength():number {
  var offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
};

/**
 * @param flatbuffers.Builder builder
 */
static startTfbEventErrorSet(builder:flatbuffers.Builder) {
  builder.startObject(1);
};

/**
 * @param flatbuffers.Builder builder
 * @param flatbuffers.Offset ErrorsOffset
 */
static addErrors(builder:flatbuffers.Builder, ErrorsOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, ErrorsOffset, 0);
};

/**
 * @param flatbuffers.Builder builder
 * @param Array.<flatbuffers.Offset> data
 * @returns flatbuffers.Offset
 */
static createErrorsVector(builder:flatbuffers.Builder, data:flatbuffers.Offset[]):flatbuffers.Offset {
  builder.startVector(4, data.length, 4);
  for (var i = data.length - 1; i >= 0; i--) {
    builder.addOffset(data[i]);
  }
  return builder.endVector();
};

/**
 * @param flatbuffers.Builder builder
 * @param number numElems
 */
static startErrorsVector(builder:flatbuffers.Builder, numElems:number) {
  builder.startVector(4, numElems, 4);
};

/**
 * @param flatbuffers.Builder builder
 * @returns flatbuffers.Offset
 */
static endTfbEventErrorSet(builder:flatbuffers.Builder):flatbuffers.Offset {
  var offset = builder.endObject();
  return offset;
};

static createTfbEventErrorSet(builder:flatbuffers.Builder, ErrorsOffset:flatbuffers.Offset):flatbuffers.Offset {
  TfbEventErrorSet.startTfbEventErrorSet(builder);
  TfbEventErrorSet.addErrors(builder, ErrorsOffset);
  return TfbEventErrorSet.endTfbEventErrorSet(builder);
}
}
}
